import { render, staticRenderFns } from "./item-table.vue?vue&type=template&id=06dafb18"
import script from "./item-table.vue?vue&type=script&lang=js"
export * from "./item-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports